import styled, { css } from 'styled-components'
import { cardisTheme } from '../../theme/cardisTheme'

const printStyles = css`
  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

const getSizeValue = (size?: 'small' | 'medium' | 'large'): string => {
  switch (size) {
    case 'small':
      return '70px'
    case 'large':
      return '200px'
    default:
      return '140px'
  }
}

export const Avatar = styled.img<{ $size?: 'small' | 'medium' | 'large' }>`
  width: ${({ $size }) => getSizeValue($size)};
  height: ${({ $size }) => getSizeValue($size)};
  border-radius: 50%;
  object-fit: cover;
  border: ${({ $size }) => ($size === 'large' ? '4px solid white' : 'none')};
  box-shadow: ${({ $size }) =>
    $size === 'large' ? '0 4px 20px rgba(0, 0, 0, 0.3)' : 'none'};

  @media print {
    width: ${({ $size }) => getSizeValue($size)} !important;
    height: ${({ $size }) => getSizeValue($size)} !important;
    border-radius: 50% !important;
    object-fit: cover !important;
    ${printStyles}
  }
`

export const AvatarPlaceholder = styled.div<{
  $size?: 'small' | 'medium' | 'large'
}>`
  width: ${({ $size }) => getSizeValue($size)};
  height: ${({ $size }) => getSizeValue($size)};
  border-radius: 50%;
  background-color: ${cardisTheme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;

  @media print {
    width: ${({ $size }) => getSizeValue($size)} !important;
    height: ${({ $size }) => getSizeValue($size)} !important;
    border-radius: 50% !important;
    background-color: ${cardisTheme.colors.primary} !important;
    ${printStyles}
  }
`
